import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import { formatPhoneNumber } from "@ui/utils/formatPhoneNumber";

import { useConfig } from "@jti/app-context/useConfig";
import { Button } from "@jti/core-components/components/Button";
import { formatFullName } from "@jti/fe-common";

import styles from "./ContactInfo.module.scss";

export type ContactInfoProps = {
  contact: {
    firstname: string;
    lastname: string;
    telephone: string;
  };
  editLabel?: string;
  onEdit?(): void;
  hidePhone?: boolean;
};

export const ContactInfo: FC<ContactInfoProps> = ({
  contact: { firstname, lastname, telephone },
  editLabel = "Edit",
  onEdit,
  hidePhone = false,
}) => {
  const config = useConfig();
  const { __ } = useTranslations();
  const { isReversedNameOrder } = config;

  return (
    <>
      <div className={styles.nameAndPhoneList}>
        <div>
          <span className={styles.label}>{__("contact_info.name")}:</span>
          <span className={styles.value}>{formatFullName(firstname, lastname, isReversedNameOrder)}</span>
        </div>
        {!hidePhone && (
          <div>
            <span className={styles.label}>{__("contact_info.phone_number")}:</span>
            <span className={styles.value}>
              {formatPhoneNumber(telephone, config.isInternationalPhoneEnabled, config.PHONE_FORMAT)}
            </span>
          </div>
        )}
      </div>
      {onEdit ? (
        <Button
          data-testid="contactInfoEditBtn"
          type="button"
          variant="text"
          size="lg"
          onClick={onEdit}
          className={styles.editButton}
        >
          {editLabel}
        </Button>
      ) : null}
    </>
  );
};
